import styled from 'styled-components';
import { token } from '@atlaskit/tokens';
import { Dimensions, Font } from 'components/visuals';

export const Header = styled.h2`
  font-family: ${Font.displayFamily};
`;

export const SubHeader = styled.h3`
  font-family: ${Font.displayFamily};
  font-size: 20px;
  margin-bottom: 14px;
`;

export const Subtle = styled.em`
  font-size: 65%;
  font-weight: normal;
  color: ${token('color.text.subtlest', '#626F86')};
  margin-left: ${Dimensions.unit}px;
  font-family: ${Font.family};
`;

export const Paragraph = styled.p`
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 24px;
`;

// Fix Atlaskit Checkbox alignment
export const RealignCheckbox = styled.span`
  margin-left: -10px;
`;

export const Fineprint = styled.p`
  color: ${token('color.icon.subtle', '#626F86')};
  font-size: 12px;
  margin-bottom: 10px;
`;

export const FooterArea = styled.div`
  border-top: 1px solid ${token('color.border.disabled', '#8590A2')}
  padding-top: 20px;
  text-align: right;
  
  button {
    padding-left: 20px;
    padding-right: 20px;
  }
`;
